module.exports = __webpack_public_path__ + "static/media/Methodology_left.baece91d.jpg";